;(function() {
  'use strict'

  Service.$inject = ["AUTH_EVENTS", "$rootScope", "$q", "userCouponsResource", "rewardFactory"];
  angular.module('core.services').factory('rewardsListService', Service)

  /* @ngInject */
  function Service(
    AUTH_EVENTS,
    $rootScope,
    $q,
    userCouponsResource,
    rewardFactory
  ) {
    $rootScope.$on('survey:responded', refresh)
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, reset)

    var states = {
      IDLE: 'idle',
      LOADING: 'loading',
      READY: 'ready',
      NONE: 'none',
      ERROR: 'error',
    }

    var rewards = {
      list: [],
      refresh: refresh,
      state: states.IDLE,
      error: null,
      states: states,
    }

    return {
      get: get,
    }

    function get() {
      rewards.promise = refresh(true)
      return rewards
    }

    function refresh(isGetter) {
      isGetter = isGetter === true
      return $q(function(resolve, reject) {
        // Currently if we have a list just return that. In future we can start
        // refreshing the list after some time has elapsed
        if (
          isGetter === true &&
          (rewards.state === states.READY || rewards.state === states.NONE)
        ) {
          resolve(rewards.list)
          return
        }
        rewards.state = states.LOADING
        userCouponsResource
          .get()
          .success(function(res, response) {
            rewardFactory.transform(response)
            angular.copy(response, rewards.list)
            resolve(rewards.list)
            rewards.state = rewards.list.length > 0 ? states.READY : states.NONE
          })
          .error(function(response, status) {
            rewards.state = states.ERROR
            reject({
              response: response,
              status: status,
            })
          })
      })
    }

    function reset() {
      angular.copy([], rewards.list)
      rewards.state = states.IDLE
    }
  }
})()
